import { StatusBar } from 'expo-status-bar';
import React from 'react';
import {
    Image,
    Platform,
    Text,
    StyleSheet,
    View,
    Button,
    Linking,
    TouchableOpacity,
} from 'react-native';
import Constants from 'expo-constants';
import * as MailComposer from 'expo-mail-composer';

/** App main. */
export default function App() {
    if (Platform.OS === 'web') {
        React.useEffect(() => {
            document.body.style.backgroundColor =
                Constants.manifest.splash.backgroundColor;
        }, []);
    }

    return (
        <View
            style={[
                StyleSheet.absoluteFill,
                styles.container,
                {
                    backgroundColor: Constants.manifest.splash.backgroundColor,
                },
            ]}
        >
            <Image
                style={[
                    styles.image,
                    {
                        resizeMode:
                            Constants.manifest.splash.resizeMode || 'contain',
                    },
                ]}
                source={require('./assets/icon400t.png')}
            />
            <Text style={styles.appHeader}>Eurrency</Text>

            <TouchableOpacity
                onPress={() =>
                    Linking.openURL(
                        'https://apps.apple.com/us/app/eurrency/id886091199',
                    )
                }
            >
                <Image
                    source={require('./assets/appstore.png')}
                    style={styles.downloadImage}
                />
            </TouchableOpacity>

            <Text style={styles.privacyHeader}>Privacy Policy</Text>
            <Text style={styles.privacyBody}>
                We do not collect, use, save or have access to any of your
                personal data recorded in Eurrency for iOS.{'\n\n'}Individual
                settings made in the app are not personal and are stored only on
                your device.
            </Text>
            <View style={styles.supportButtonContainer}>
                <Button
                    title='Feedback and Support'
                    onPress={() =>
                        MailComposer.composeAsync({
                            recipients: ['support@diatche.com'],
                            subject: 'Eurrency - Feedback and Support',
                            body: '',
                        })
                    }
                />
            </View>
            <View style={styles.flex} />
            <Text style={styles.footer}>© 2014 - 2021 Pavel Diatchenko</Text>
            <StatusBar style='light' />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        flexGrow: 1,
    },
    image: {
        width: 200,
        height: 200,
        marginTop: 40,
    },
    flex: {
        flex: 1,
    },
    appHeader: {
        width: '100%',
        padding: 8,
        color: '#e08300',
        textAlign: 'center',
        fontSize: 32,
        fontWeight: 'bold',
        marginBottom: 20,
    },
    downloadImage: {
        width: 160,
        height: 54,
        marginBottom: 40,
    },
    privacyHeader: {
        width: '100%',
        padding: 8,
        color: '#595959',
        textAlign: 'center',
        fontSize: 22,
        fontWeight: 'bold',
    },
    privacyBody: {
        width: '100%',
        padding: 8,
        color: '#595959',
        textAlign: 'center',
        fontSize: 14,
    },
    supportButtonContainer: {
        margin: 40,
    },
    footer: {
        width: '100%',
        padding: 8,
        color: '#595959',
        textAlign: 'center',
        fontSize: 12,
    },
});
